import React, { useEffect, useState, useCallback } from "react";
import FormInput from "components/atoms/FormInput";
import PageTitle from "components/atoms/PageTitle";
import { useLocation, useNavigate } from "react-router-dom";
import Alert from "components/atoms/Alert";
import Spinner from "components/atoms/Spinner";
import { getValues, setValues } from "services/storage";
import Button from "components/atoms/Button";
import { connect, useDispatch, useSelector } from "react-redux";
import { SET_COUNTRIES } from "redux/app/app.type";
import axios from "services/axios";
import {
  getRequest,
  BASE_URL,
  putRequest,
  loggedUser_baseURL,
} from "services/http";
import KYCForms from "modules/kycForms";
import { setUserLoggedIn } from "redux/auth/auth.action";
import returnIcon from "../../../assets/svg/arrow-left.svg";
import arrowDown from "../../../assets/svg/arrow-down.svg";
import {
  updateAddress,
  updateCity,
  updateBvnId,
  updateStateName,
  updateKycDocuments,
} from "redux/formAction";
// import { use } from "i18next";

const acceptedFileExt = {
  "text/pdf": [".pdf"],
};

const KYCInformation = (props) => {
	const [loading, setLoading] = useState(false);
	const [loadingKyc, setLoadingKyc] = useState(false);
	const [formOverflow, setFormOverflow] = useState(false);
	const [hideArrow, setHideArrow] = useState(false);
	const [scrolledToBottom, setScrolledToBottom] = useState(false);
	const [addField, setAddField] = useState(false);
	const [kycDocuments, setKYCDocuments] = React.useState(null);
	const [kycDocList, setKycDocList] = useState<any>([]);
	const [countries, setCountries] = useState<any>([]);
	const [errorStatus, setErrorStatus] = useState(false);

	const [field, setField] = useState(null);
	const [value, setValue] = useState<any>([]);
	const [bvnId, setBvnId] = useState('');
	const [bvnIdErr, setBvnIdErr] = useState('');

	const [address, setAddress] = useState('');
	const [city, setCity] = useState('');
	const [state, setState] = useState('');

	const username = getValues('username');
	const auth_token = getValues('auth_token');
	const navigate = useNavigate();
	const location: any = useLocation();

	const profileStatus_settlement =
		location?.state?.profileStatus?.step1 === 'COMPLETED' ? true : false;

	const stateVar = location?.state?.progressData;
	
	const formComplete =
		address !== '' ||
		city !== '' ||
		state !== '' ||
		value.length === kycDocList.length;
	const disabledBtn = loading;
	const disabledAddBtn = null;

	const dispatch = useDispatch();
	const bearerToken = useSelector(
		(state: any) => state.auth.user_authData?.token.token
	);

	const partnerCountry = countries?.find(
		(c: { name: string }) =>
			c.name.toLowerCase() === props?.user_authData.country.toLowerCase()
	);

	const getRequiredKYC = async () => {
		setLoadingKyc(true);
		const res = await getRequest(
			// `${BASE_URL}api/v1/admin/${props.user_authData?.partnerEmail}/documents`
			`${BASE_URL}api/v1/business/kycdocuments`, {
				'Content-Type': 'application/json',
				"Authorization": `Bearer ${props.bearerToken}`,
			},
		);

		if (res?.data.responseCode === '00') {
			const updatedData = res?.data.data.map((item: any) => ({
				...item,
				required: true,
			}));
			setKycDocList(updatedData);
			setLoadingKyc(false);
		}
		setLoadingKyc(false);
	};

	const goToNext = () => {
		if (profileStatus_settlement) {
			// Alert('success', 'Login was successful');
			props.setUserLoggedIn(true);
		} else {
			navigate('/auth/emails_info', {
				state: {
					address: {
						street: address,
						city: city,
						state: state,
					},
					kycInfo: {
						value: value,
					},
					auth_token: auth_token,
					bvn: bvnId,
				},
			});
		}
	};

	// api/v1/business/kycdocuments

	const verifyKYC = async (requestData: any) => {
		setLoading(true);
		const res = await putRequest(
			`${BASE_URL + loggedUser_baseURL}update`,
			{
				'Content-Type': 'application/json',
				"Authorization": `Bearer ${props.bearerToken}`,
			},
			requestData
		);

		if (res?.data.responseCode === '00') {
			Alert('success', res?.data.message);
			props.setUserLoggedIn(true);

			// setTimeout(() => {
			//     Alert('success', 'Login was successful');
			//     setLoading(false);
			// }, 1500);
		} else {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (kycDocList.length > 0) {
			setValue(kycDocList.filter((item) => item?.kycDocumentUrl?.length > 0));
		}
	}, [kycDocList]);

	const handleSubmit = (e) => {
		e.preventDefault();

		if (address !== '' || city !== '' || state !== '') {
			if (value.length === kycDocList.length) {
				if (profileStatus_settlement) {
					verifyKYC({
						address: {
							street: address,
							city: city,
							state: state,
							country: '',
						},
						bvn: bvnId,
						...(value?.length > 0 ? { kycDoc: value } : {}),
					});
				} else {
					goToNext();
				}
			} else {
				return Alert('warning', `Please add all required files or skip`);
			}
		} else {
			return Alert('warning', `Please fill all required fields or skip`);
		}
	};

	const removeFieldHandler = () => {
		if (value.length === 4) {
			setValue(value.filter((item) => item.required === true));
		}
	};

	const handleBvnInput = (e) => {
		const inputNum = /^[0-9]*$/;

		if (inputNum.test(e.target.value) && e.target.value.length <= 11)
			setBvnId(e.target.value);
	};

	const getCountries = async () => {
		const res = await getRequest(process.env.REACT_APP_COUNTRIES_URL!);

		if (res?.status === 200) {
			setCountries(res?.data.payload);
		}
	};

	const kycFormContainer = document.getElementById('kyc_forms_secton');

	kycFormContainer?.addEventListener('scroll', () => {
		setScrolledToBottom(kycFormContainer.scrollTop + kycFormContainer.clientHeight >= kycFormContainer.scrollHeight);
	});

	const scrollToSection = () => {
		document.getElementById("end_of_form")?.scrollIntoView({ behavior: 'smooth' });
	}

	const getFormLenght = () => {

		const sectionHeight = kycFormContainer?.offsetHeight || 0;
		const isOverFlowingY = (kycFormContainer?.scrollHeight || 0) > sectionHeight;

		setFormOverflow(isOverFlowingY);
	}

	useEffect(() => {
		getRequiredKYC();
	}, []);

	useEffect(() => getFormLenght(), [formOverflow]);

	useEffect(() => {
		if (countries.length < 1) {
			getCountries();
		}
	}, [countries]);

	useEffect(() => {
		if (scrolledToBottom) {
			setHideArrow(true);
		} else {
			setHideArrow(false);
		}
	}, [scrolledToBottom]);

	console.log('kycDocList', kycDocList);
	console.log('value', value);

	return (
		<form
			onSubmit={handleSubmit}
			className="relative flex flex-col gap-5 max-w-sm w-full h-fit max-h-[650px]"
		>
			<div className="flex flex-col gap-0">
				<span
					className="flex items-center gap-1 cursor-pointer font-normal text-sm"
					onClick={() => navigate('/auth/login')}
				>
					<img src={returnIcon} alt="return" className="w-[10px] h-[10px]" />
					Back
				</span>
				<PageTitle
					pageTitle="Enter KYC Information"
					pageTitleStyle="font-semibold !text-2xl tablet:!text-xl"
					subTitle="Upload business documents"
					subTitleStyle="!text-sm leading-5 !text-Black2"
					style="!mb-0 !pb-0"
				/>
			</div>
			{/* {fetchingKYC && <div className="animate-pulse" role='status'>
                <div className="mb-3 h-10 w-full rounded bg-gray-200"></div>
                <div className="mb-3 h-10 w-full rounded bg-gray-200"></div>
                <div className="mb-3 h-10 w-full rounded bg-gray-200"></div>
            </div>} */}
			<div className="flex flex-col gap-3 overflow-y-scroll custom_container" id='kyc_forms_secton'>
				<span className="font-semibold text-sm">
					<span className="!text-[10px]">Required</span>
					<span style={{ color: 'rgb(255 34 0)' }} className="font-16">
						*
					</span>
				</span>
				<div className="flex flex-col">
					<FormInput
						type={'text'}
						name="address"
						placeholder="Enter Address"
						style="w-full"
						inputStyle="border border-transparent text-Black2"
						required={true}
						label="Address"
						labelStyle="font-semibold text-sm leading-6 text-Black2"
						value={address}
						onChange={(e) => setAddress(e.target.value)}
					/>

					<div className="flex justify-between items-center gap-5">
						<FormInput
							type={'text'}
							name="city"
							placeholder="Enter City"
							style="w-full"
							inputStyle="border border-transparent text-Black2"
							required={true}
							label="City"
							labelStyle="font-semibold text-sm leading-6 text-Black2"
							value={city}
							onChange={(e) => setCity(e.target.value)}
						/>
						<FormInput
							type={'text'}
							name="state"
							placeholder="Enter State/Province"
							style="w-full"
							inputStyle="border border-transparent text-Black2"
							required={true}
							label="State/Province"
							labelStyle="font-semibold text-sm leading-6 text-Black2"
							value={state}
							onChange={(e) => setState(e.target.value)}
						/>
					</div>

					{partnerCountry?.countryCode === 'NG' && (
						<FormInput
							type={'text'}
							name="bvn"
							placeholder="Enter BVN"
							style="w-full"
							inputStyle="border border-transparent text-Black2"
							required={true}
							label="BVN"
							labelStyle="font-semibold text-sm leading-6 text-Black2"
							value={bvnId}
							validationErr={errorStatus ? bvnIdErr : ''}
							onChange={handleBvnInput}
						/>
					)}
				</div>

		

				<div className="flex flex-col">
					{kycDocList &&
						kycDocList.map((item: any, i) => (
							<KYCForms
								key={i}
								field={field}
								setField={setField}
								data={item}
								value={value}
								required={item.required}
								handleValue={(e) => {
									setValue({ ...value, [e.target.name]: e.target.value });
								}}
								setValue={setValue}
								kycDocuments={kycDocuments}
								setKYCDocuments={setKYCDocuments}
								addField={addField}
								setAddField={setAddField}
								handleRemoveAddedField={getRequiredKYC}
								removeFieldHandler={removeFieldHandler}
							/>
						))}
				</div>
				<div id='end_of_form'></div>
			</div>
			<span className="font-normal text-xs text-BackDrop_d_xl">
				Accepted file format must be <b>pdf</b>
			</span>
			{/* <span className='font-normal text-xs text-BackDrop_d_xl'>Accepted file formats include <b>pdf, ppt, docx, jpg, jpeg and png</b></span> */}
			<div className="flex justify-between">
				<button onClick={goToNext} className="text-red-500 bg-none border-none">
					Skip
				</button>
				<Button
					btnType="submit"
					btnText={
						loading
							? 'Loading...'
							: `${profileStatus_settlement ? 'Submit' : 'Next'}`
					}
					btnStyle={`${disabledBtn ? 'cursor-not-allowed' : ''
						} bg-black text-white px-6 py-3 w-fit`}
					onClick={() => { }}
				/>
			</div>
			{kycDocList?.length > 0 &&  <span onClick={scrollToSection} className={`${!hideArrow ? 'flex' : 'hidden'} justify-center items-center border border-GrayCustom absolute w-7 h-7 rounded-full mx-auto right-0 left-0 bottom-7 animate-bounce cursor-pointer`}>
				<img src={arrowDown} alt='indicator_icon' className='w-3/5 h-3/5' />
			</span>}
		</form>
	);
};

const mapStateToProps = (state: any) => ({
  user_authData: state.auth.user_authData,
  bearerToken: state.auth.user_authData?.token.token,
});

const mapDispatchToProps = (dispatch: any) => ({
  setUserLoggedIn: (data: boolean) => dispatch(setUserLoggedIn(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(KYCInformation);
